import { render, staticRenderFns } from "./ResetPw.vue?vue&type=template&id=21805ac6&scoped=true&"
import script from "./ResetPw.vue?vue&type=script&lang=js&"
export * from "./ResetPw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21805ac6",
  null
  
)

export default component.exports